import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CoursesDetail = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>
            這堂課適合誰? <br />
            我可以在這堂課獲得什麼?
          </span>
        </h2>
        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>
              完成這堂課之後，你能:
            </span>
          </motion.h5>
        </div>
        <ol>
          <li>
            準備好你自己回答<span>Coding Interview面試</span>中的問題
          </li>
          <li>
            能夠用程式碼表現出
            <span>
              「歐幾里得演算法」、「歐拉函數」、「河內塔問題」、「最小公倍數演算法」、「斐波那契數列」、「線性遞迴關係式」
            </span>
            、還有其他重要的演算法!
          </li>
          <li>學會推導邏輯與驗證程式碼邏輯正確性。</li>
          <li>用邏輯來證明數學理論，做為資料科學的的重要演算法基礎。</li>
          <li>從學習數論與集合理論，作為學習質數與密碼學的重要演算法基礎。</li>
          <li>
            學會圖形演算法，例如
            <span>
              「Floyd-Warshall 演算法 (Dynamic Programming)」、「Dijkstra's
              Algorithm」、「Depth First Traversal」、「Breadth First
              Traversal」
            </span>
            。
          </li>
        </ol>

        <br />

        <div style={{ overflow: "hidden" }}>
          <motion.h5 variants={hideAnimation}>
            <span style={{ textDecoration: "underline" }}>這堂課是設計給:</span>
          </motion.h5>
        </div>
        <ol>
          <li>對資料科學、機器學習、人工智慧有興趣的Python開發工程師</li>
          <li>對網頁前端後端有興趣，能夠使用基本JavaScript的工程師</li>
          <li>正在大學就讀資訊工程、電腦科學、資料科學、數學的學生</li>
          <li>對於演算法與網路結構有興趣者</li>
          <li>對於研究應用數學有興趣的人</li>
          <li>正在準備學習演算法以及資料結構的人</li>
        </ol>
      </motion.div>
      <div className="images">
        <img src={props.img} alt="" />
      </div>
    </div>
  );
};

export default CoursesDetail;
